import styled, { css } from 'styled-components'
import { primaryColor } from 'uiComponents/constants/colors'
import {
  fontFamilyPrimary,
  fsXS,
  fwMediumBold,
} from 'uiComponents/constants/typography'

const baseCss = css`
  ${fontFamilyPrimary};
  ${fwMediumBold};
  letter-spacing: auto;
  color: ${primaryColor};
`
export const ParagraphXS = styled.p`
  ${baseCss};
  font-size: ${fsXS}px;
  line-height: calc(9 / 7);
`
